import { render, staticRenderFns } from "./PageFeaturesCard.vue?vue&type=template&id=1afb9d6b&scoped=true"
import script from "./PageFeaturesCard.vue?vue&type=script&lang=js"
export * from "./PageFeaturesCard.vue?vue&type=script&lang=js"
import style0 from "./PageFeaturesCard.vue?vue&type=style&index=0&id=1afb9d6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb9d6b",
  null
  
)

export default component.exports